"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "zocca": {
    "4f532f57": [{
      "hkey": "e386f186",
      "slug": "zocca",
      "name": "Zocca",
      "primary": true,
      "skipSearch": false
    }],
    "arenata": [{
      "hkey": "e386f186",
      "slug": "zocca",
      "name": "Zocca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "46f5abdd": [{
      "hkey": "ec958267",
      "slug": "casa-miro-montetortore",
      "name": "Casa Miro-Montetortore",
      "primary": true,
      "skipSearch": false
    }],
    "casa-miro": [{
      "hkey": "ec958267",
      "slug": "casa-miro-montetortore",
      "name": "Casa Miro-Montetortore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "zocca"
    }],
    "43f5004c": [{
      "hkey": "e386f186",
      "slug": "zocca",
      "name": "Zocca",
      "primary": true,
      "skipSearch": false
    }],
    "le-strade": [{
      "hkey": "e386f186",
      "slug": "zocca",
      "name": "Zocca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0021aa74": [{
      "hkey": "cc063dc3",
      "slug": "montalbano-cantone",
      "name": "Montalbano-Cantone",
      "primary": true,
      "skipSearch": false
    }],
    "montalbano": [{
      "hkey": "cc063dc3",
      "slug": "montalbano-cantone",
      "name": "Montalbano-Cantone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ac6c4399": [{
      "hkey": "ec958267",
      "slug": "casa-miro-montetortore",
      "name": "Casa Miro-Montetortore",
      "primary": true,
      "skipSearch": false
    }],
    "montetorto": [{
      "hkey": "ec958267",
      "slug": "casa-miro-montetortore",
      "name": "Casa Miro-Montetortore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;